import _ from 'lodash';
import MenuButton, { MenuButtonItem } from 'components/MenuButton';
import Icon from 'components/base/Icon';
import { exportPNG } from 'components/ExportFile';

const getDefaultElements = ({ onClick, pngFileName }) => [
  <MenuButtonItem
    key='Export as PNG'
    text='Export as PNG'
    icon={<Icon name='Download' color='nepal' size='smaller' />}
    onClick={() => {
      onClick();
      exportPNG(pngFileName);
    }}
  />
];

const ShareMenuButton = ({
  pngFileName,
  onClick = _.noop,
  additionalMenuElements = [],
  variant = 'default'
}) => {
  return (
    <div data-html2canvas-hide='true'>
      <MenuButton
        width='20rem'
        buttonText='Share'
        padding='x-x-x-small'
        dataCy='share-button'
        buttonVariant={variant}
        items={[
          ...additionalMenuElements,
          ...getDefaultElements({ onClick, pngFileName })
        ]}
      />
    </div>
  );
};

export default ShareMenuButton;
